import { render, staticRenderFns } from "./EnhanceAccountRegistrationNumberUpdate.vue?vue&type=template&id=a5adce16&scoped=true"
import script from "./EnhanceAccountRegistrationNumberUpdate.vue?vue&type=script&lang=js"
export * from "./EnhanceAccountRegistrationNumberUpdate.vue?vue&type=script&lang=js"
import style0 from "./EnhanceAccountRegistrationNumberUpdate.vue?vue&type=style&index=0&id=a5adce16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5adce16",
  null
  
)

export default component.exports